// extracted by mini-css-extract-plugin
export default {"forminputs":"Checkout_forminputs__kkeyE","input":"Checkout_input__Z8V2R"};